<!-- app-subdomain-creators\src\accountPages\CreatorUsers.vue -->

<template>
  <div class="">
    <div class="mt-4 sm:ml-10 lg:ml-0 sm:mt-0 lg:mt-5 px-24">
      <nav class="-mb-px flex space-x-8">
        <router-link
          v-for="tab in tabs"
          :key="tab.name"
          :to="tab.to"
          :class="[tab.current ? 'border-[#2D8CFF] text-[#2D8CFF]' : 'border-transparent text-zinc-500 hover:border-zinc-300 hover:text-zinc-700', 'whitespace-nowrap border-b-2 px-1 pb-4 text-sm font-medium']"
          aria-current="tab.current ? 'page' : undefined"
        >
          {{ tab.name }}
        </router-link>
      </nav>
    </div>
  </div>

  <!-- Nested route content -->
  <div class="mt-6">
    <router-view />
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, watch } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
// Initialize the tabs array with routes and default current state
const tabs = ref([
  { name: 'Leads', to: '/creator/users/leads', current: false },
  { name: 'Members', to: '/creator/users/members-list', current: false },
  { name: 'Tags', to: '/creator/users/members-tags', current: false },
]);

// Function to update tab activation based on current route
const updateActiveTab = () => {
  const currentPath = route.path;

  // Remove the "Member Details" tab when on "Members List" or "Tags"
  if (
    currentPath === '/creator/users/leads'
    || currentPath === '/creator/users/members-list'
    || currentPath === '/creator/users/members-tags'
  ) {
    tabs.value = tabs.value.filter((tab) => !tab.name.startsWith('Member:') && !tab.name.startsWith('Lead:'));
  }

  // Activate the tab that matches the current path
  tabs.value.forEach(tab => {
    tab.current = tab.to === currentPath;
  });
};

// Handle the member-selected event and dynamically add the "Member Details" tab
const handleMemberSelected = event => {
  const member = event.detail;

  // Remove existing "Member Details" tab to avoid duplicates
  tabs.value = tabs.value.filter(tab => !tab.name.startsWith('Member:'));

  // Add a new "Member Details" tab and set it as active
  tabs.value.push({
    name: `Member: ${member.name}`,
    to: `/creator/users/members-details/${member.userId}`,
    current: true,
  });

  // Deactivate all other tabs
  tabs.value.forEach(tab => {
    tab.current = tab.to === `/creator/users/members-details/${member.userId}`;
  });
};

const handleLeadSelected = event => {
  const lead = event.detail;
  tabs.value = tabs.value.filter((tab) => !tab.name.startsWith('Lead:'));
  tabs.value.push({
    name: `Lead: ${lead.name}`,
    to: `/creator/users/leads-details/${lead.id}`,
    current: true,
  });
  tabs.value.forEach(tab => {
    tab.current = tab.to === `/creator/users/leads-details/${lead.id}`;
  });
};

// Watch route changes to update the active tab
watch(() => route.path, updateActiveTab);

// Set up and clean up the custom event listener
onMounted(() => {
  window.addEventListener('member-selected', handleMemberSelected);
  window.addEventListener('lead-selected', handleLeadSelected);
  updateActiveTab(); // Set initial active tab based on current route
});

onBeforeUnmount(() => {
  window.removeEventListener('member-selected', handleMemberSelected);
  window.removeEventListener('lead-selected', handleLeadSelected);
});
</script>

  
  
